import { render, staticRenderFns } from "./qiyuKFManagement.vue?vue&type=template&id=34247215&scoped=true"
import script from "./qiyuKFManagement.vue?vue&type=script&lang=ts"
export * from "./qiyuKFManagement.vue?vue&type=script&lang=ts"
import style0 from "./qiyuKFManagement.vue?vue&type=style&index=0&id=34247215&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34247215",
  null
  
)

export default component.exports